export default __webpack_public_path__ + "static/media/ultramart.c9d3ad08.png";